import React, { FC } from 'react';

export const HiddenSubmit: FC = () => {
  return <input type="submit" style={{ display: 'none' }} />;
};
